var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.aiChatbotFlag)?_c('yy-chatbot-view',{attrs:{"id":"yy-chatbot-view","chat-config":"{}"},on:{"chat-change":_vm.onchatChange}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }